import React from 'react';

interface VisionIconProps {
  className?: string;
  size?: number;
}

export const VisionIcon: React.FC<VisionIconProps> = ({ 
  className = '', 
  size = 150 
}) => {
  return (
    <svg 
      id="Layer_1" 
      xmlns="http://www.w3.org/2000/svg" 
      version="1.1" 
      viewBox="0 0 150 150"
      width={size}
      height={size}
      className={className}
    >
      <defs>
        <style>
          {`.st0 {
            fill: none;
            stroke: #e3e3e3;
            stroke-linecap: round;
            stroke-linejoin: round;
            stroke-width: 9px;
          }`}
        </style>
      </defs>
      <line className="st0" x1="20.55" y1="102.71" x2="17.1" y2="104.47"/>
      <path className="st0" d="M33.75,99.04c-3.83-7.55-.82-16.78,6.73-20.61"/>
      <path className="st0" d="M40.72,116.61c-8.35-.89-16.09-5.86-20.17-13.9-6.41-12.63-1.37-28.07,11.26-34.48,12.63-6.41,28.07-1.37,34.48,11.26s1.37,28.07-11.26,34.48"/>
      <line className="st0" x1="132.9" y1="45.68" x2="129.45" y2="47.43"/>
      <path className="st0" d="M96.91,66.98c-3.83-7.55-.82-16.78,6.73-20.61"/>
      <path className="st0" d="M107.23,84.69c-9.58.24-18.89-4.93-23.52-14.04-6.41-12.63-1.37-28.07,11.26-34.48,12.63-6.41,28.07-1.37,34.48,11.26,5.94,11.69,2.06,25.79-8.57,32.91"/>
      <path className="st0" d="M65.81,78.56c-2.44-4.81-.52-10.69,4.29-13.13,4.81-2.44,10.69-.52,13.13,4.29"/>
    </svg>
  );
};
